import { BaseStore } from "@omni/types/enums/baseStore.enum";
import { fromEntries, values } from "@omni/utils/object.utils";
import * as yup from "yup";

export const yupBaseStoreAware = <T extends yup.Schema>(ref: T) => {
    return yup.object(
        fromEntries(values(BaseStore).map((baseStore) => [baseStore, ref]))
    );
};
